import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import CheckFormWrapper from '../shared/CheckFormWrapper';
import FileUploadField from '../shared/FileUploadField';
import TagsInput from '../shared/TagsInput';

/**
 * PasswordCheckForm
 *
 * Evaluates password-parameter compliance by comparing system settings
 * against a list of recommended values.
 *
 * API: POST /helper/password-check
 *
 * Props:
 *   onSubmit   - (FormData) => void
 *   isLoading  - bool
 */
export default function PasswordCheckForm({ onSubmit, isLoading = false }) {
  const [inputFile, setInputFile] = useState(null);
  const [parameterFile, setParameterFile] = useState(null);

  // [parameterCol, recommendedCol, userSettingCol, systemDefaultCol]
  const [parameterNameCol, setParameterNameCol] = useState([]);
  const [parameterNameColError, setParameterNameColError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (parameterNameCol.length !== 4) {
      setParameterNameColError(
        'Add exactly four column names in order: parameter name, recommended value, user setting, system default'
      );
      return;
    }
    setParameterNameColError('');

    const formData = new FormData();
    formData.append('inputFile', inputFile);
    formData.append('listOfParameterFile', parameterFile);
    formData.append('parameterNameCol', JSON.stringify(parameterNameCol));

    onSubmit(formData);
  };

  return (
    <CheckFormWrapper
      title="Password Check"
      description="Compares password parameter settings against recommended values to determine compliance effectiveness."
      onSubmit={handleSubmit}
      isLoading={isLoading}
    >
      <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
        <FileUploadField
          label="Password Parameter Extract"
          file={inputFile}
          onChange={setInputFile}
          required
          helperText=".csv or .xlsx – contains system password settings"
        />
        <FileUploadField
          label="Recommended Parameters File"
          file={parameterFile}
          onChange={setParameterFile}
          required
          helperText=".csv or .xlsx – contains recommended values per parameter"
        />
      </Box>

      <Box>
        <TagsInput
          label={
            <>
              Column Mappings <span style={{ color: '#d32f2f' }}>*</span>
            </>
          }
          values={parameterNameCol}
          onChange={(next) => {
            setParameterNameCol(next);
            if (next.length === 4) setParameterNameColError('');
          }}
          maxValues={4}
          placeholder="Next column name, then Enter or Add"
          helperText="Order: (1) parameter name — merge key, (2) recommended value, (3) user setting, (4) system default. Add each as a chip; max four."
        />
        {parameterNameColError && (
          <Typography
            variant="caption"
            color="error"
            sx={{ display: 'block', mt: 0.5 }}
          >
            {parameterNameColError}
          </Typography>
        )}
      </Box>
    </CheckFormWrapper>
  );
}
